var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flag"},[_c('el-card',[_c('main',[_c('h2',[_vm._v("华统集团")]),_c('img',{attrs:{"src":"https://27273414.s21i.faiusr.com/2/ABUIABACGAAg-ai4hQYo1M35iAIw6wc4ogM.jpg.webp","alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }